<div class="filter-container">
  @if (!isExternalTenant()) {
    <div class="filter-item">
      <label class="label" for="tenantSelect">Kunden</label>
      <wr-tenant-select id="tenantSelect"
                        [ngModel]="selectedTenantId()"
                        (ngModelChange)="onTenantChange($event)"
                        [tenantType]="TenantTypeEnum.External"
                        [showEmptyOption]="showAll()">
      </wr-tenant-select>
    </div>
  }
  <span class="building-count">{{ buildingCount() }} Gebäude</span>
</div>
<div id="map"></div>
<div #hidden id="hidden"></div>
